"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CarListingOfferListItemComponent_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/CarListingOfferListItemComponent"));
const ITEMS_PER_PAGE = process.env.APP_ENV === 'test' ? 5 : 20;
const CarListingOfferList = ({ listingOffers, isSmallScreen, handleMergedOfferClick, filterCount, paging, handlePagingChange, }) => {
    const totalItems = listingOffers.length;
    const totalPages = (0, react_1.useMemo)(() => Math.ceil(totalItems / ITEMS_PER_PAGE), [totalItems]);
    const currentPageNumber = (0, react_1.useMemo)(() => Math.max(...paging), [paging]);
    const currentOffers = (0, react_1.useMemo)(() => paging.flatMap((pageNumber) => {
        const startIndex = (pageNumber - 1) * ITEMS_PER_PAGE;
        return listingOffers.slice(startIndex, startIndex + ITEMS_PER_PAGE);
    }), [listingOffers, paging]);
    const loadMorePages = () => {
        const currentScrollY = window.scrollY;
        const nextPage = currentPageNumber + 1;
        if (nextPage <= totalPages) {
            handlePagingChange([...paging, nextPage]);
        }
        setTimeout(() => {
            window.scrollTo(0, currentScrollY);
        }, 0);
    };
    const goToPage = (newPage) => {
        if (newPage === currentPageNumber) {
            return;
        }
        handlePagingChange([newPage]);
    };
    const renderPaginationButtons = () => {
        const pageButtons = [];
        pageButtons.push(react_1.default.createElement("span", { key: "prev", className: `page prev ${currentPageNumber === 1 ? 'disabled' : ''}`, onClick: () => currentPageNumber > 1 && goToPage(currentPageNumber - 1) }));
        for (let page = 1; page <= totalPages; page++) {
            pageButtons.push(react_1.default.createElement("span", { key: page, onClick: () => goToPage(page), className: `page ${currentPageNumber === page ? 'active' : ''}` }, page));
        }
        pageButtons.push(react_1.default.createElement("span", { key: "next", className: `page next ${currentPageNumber === totalPages ? 'disabled' : ''}`, onClick: () => currentPageNumber < totalPages && goToPage(currentPageNumber + 1) }));
        return pageButtons;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: `listing-item-offers-list${isSmallScreen ? '' : ' linear-listing'}` }, currentOffers.map((listingOffer) => (react_1.default.createElement(CarListingOfferListItemComponent_1.default, { key: listingOffer.simpleOfferList.getFirstOffer().id, listingOffer: listingOffer, simpleOffer: listingOffer.simpleOfferList.getFirstOffer(), handleClick: handleMergedOfferClick, showMergedOffer: listingOffer.simpleOfferList.getCount() > 1, isSmallScreen: isSmallScreen, filterCount: filterCount, isListingOffersListEmpty: false })))),
        totalPages > 1
            && react_1.default.createElement("div", { id: "listing-paging", className: "pagination-controls" }, renderPaginationButtons()),
        currentPageNumber < totalPages
            && react_1.default.createElement("div", { id: "listing-paging-load-more", className: "load-more-wrapper" },
                react_1.default.createElement("button", { onClick: loadMorePages, className: "load-more" }, "Zobrazit dal\u0161\u00ED nab\u00EDdky"))));
};
exports.default = CarListingOfferList;
